import React, { useState, useEffect, useContext, useRef } from "react";
import {
  Card,
  CardContent,
  TextField,
  Button,
  makeStyles,
  Container,
  Chip,
  Avatar,
  Paper,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Fade,
  Zoom,
} from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import PaymentOptions from "./PaymentOptions";
import ClientInfoCard from "./ClientInfoCard";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { ArrowBack } from "@material-ui/icons";
import { useCart } from "../Context/CartContext";
import { StaffCommissionDetailContext } from "../Context/StaffCommissionDetailsContext";
import { initialState } from "../initialState";
import { useSnackbar } from "react-simple-snackbar";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useCurrency } from "../Context/CurrencyContext";
import { useDiscount } from "../Context/DiscountContext";
import {
  createInvoice,
  deleteInvoice,
  getInvoice,
  updateInvoice,
} from "../actions/invoiceActions";
import { updateStaffCommissionDetails } from "../actions/staffCommissionDetailActions";
import { getAllClients } from "../actions/clientActions";
import SaveIcon from "@material-ui/icons/Save";
import { usePayNow } from "../Context/PayNowContext";
import BillDialog from "./BillDialog";
import CardDialog from "./CardDialog";
import { createStock, deleteStockById } from "../actions/stockActions";
import AddClient from "../components/Invoice/AddClient";
import { StockContext } from "../Context/StockContext";
import SeatSelection from "./SeatSelection";
import { getBookedSeats } from "../actions/seatActions";
import { fetchTripNumber, resetSeatsAndIncrement } from "../api/index";
import { useSeatless } from "../Context/SeatlessContext";
import { getAutoSelectedSeats, getAutoSelectedVipSeats } from "./SeatSelection";
import { fetchBogies, fetchBookedSeats } from "../api/index";
import "./SeatSelectionScrollbar.css";
import axios from "axios";

const useStyles = makeStyles((theme) => ({
  card: {
    maxWidth: 700,
    margin: "auto",
    marginTop: theme.spacing(4),
    padding: theme.spacing(3),
    boxShadow: "0 6px 12px rgba(0,0,0,0.15)",
    borderRadius: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
  },
  formControl: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  backButton: {
    position: "absolute",
    top: theme.spacing(2),
    left: theme.spacing(2),
    color: theme.palette.primary.main,
  },
  saveButton: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(3),
  },
  chip: {
    margin: theme.spacing(0.5),
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.common.white,
    maxWidth: "100%",
    height: "auto",
    alignItems: "flex-start",
    padding: theme.spacing(1),
    "& .MuiChip-label": {
      whiteSpace: "normal",
      overflow: "visible",
      textOverflow: "clip",
      display: "block",
      lineHeight: 1.3,
      textAlign: "left",
      overflowWrap: "anywhere",
      wordBreak: "break-word",
      width: "100%",
    },
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
    },
  },
  newCustomerChip: {
    marginBottom: theme.spacing(2),
    cursor: "pointer",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "scale(1.05)",
    },
  },
  dialog: {
    "& .MuiDialog-paper": {
      borderRadius: theme.spacing(2),
      padding: theme.spacing(2),
    },
  },
  sectionTitle: {
    fontWeight: "bold",
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(2),
  },
  autocomplete: {
    minWidth: 250,
    marginBottom: theme.spacing(2),
  },
  button: {
    borderRadius: 20,
    textTransform: "none",
    padding: theme.spacing(1, 3),
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "scale(1.05)",
    },
  },
  invoiceNumber: {
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(2),
  },
}));

const options = {
  position: "bottom",
  style: {
    backgroundColor: (theme) => theme.palette.error.main,
    border: `2px solid ${(theme) => theme.palette.error.main}`,
    color: (theme) => theme.palette.common.white,
    fontFamily: "Roboto, sans-serif",
    fontSize: "18px",
    textAlign: "center",
  },
  closeStyle: {
    color: (theme) => theme.palette.error.light,
    fontSize: "14px",
  },
};

const PaymentDetails = ({ invoiceId }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const {
    cartItems,
    setCartItems,
    getTotalPrice,
    receivedAmount,
    setReceivedAmount,
    calculateChange,
    calculateVat,
    getSubTotalPrice,
    calculateDiscount,
    getInvoiceNumber,
    roundoff,
  } = useCart();
  const [bogies, setBogies] = useState([]);
  const [resetTrigger, setResetTrigger] = useState(0);
  const [isComplimentary, setIsComplimentary] = useState(false);
  const { getConvertedQuantity } = useContext(StockContext);
  const { staffCommissionDetailsArray } = useContext(
    StaffCommissionDetailContext
  );
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const { currency, updateCurrency } = useCurrency();
  const [invoiceData, setInvoiceData] = useState(initialState);
  const [openSnackbar] = useSnackbar(options);
  const [error, setError] = useState("");
  const { invoice } = useSelector((state) => state.invoices);
  const user = JSON.parse(localStorage.getItem("profile"));
  const clients = useSelector((state) => state.clients.clients);
  const [client, setClient] = useState(null);
  const [status, setStatus] = useState("");
  const [defaultClient, setDefaultClient] = useState(null);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const {
    discountFlag,
    clearDiscount,
    discountVal,
    discountType,
    discountRate,
  } = useDiscount();
  const [itemsData, setItemsData] = useState([]);
  const [openBillDialog, setOpenBillDialog] = useState(false);
  const [openCardDialog, setOpenCardDialog] = useState(false);
  const today = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
    .toISOString()
    .slice(0, 10);
  const [tripDate, setTripDate] = useState(today);
  const [seatModalOpen, setSeatModalOpen] = useState(false);
  const [tempSelectedSeats, setTempSelectedSeats] = useState(
    invoiceData.selectedSeats || []
  );
  const [tripNumber, setTripNumber] = useState(1);
  const { seatlessMode, setToggleLocked } = useSeatless();
  const [printerName, setPrinterName] = useState(null);
  const dispatch = useDispatch();
  const history = useHistory();

  const handleBillDialogClose = () => {
    setOpenBillDialog(false);
  };

  // Calculate totalQtyToyTrainRegular
  const totalQtyToyTrainRegular = cartItems.reduce((total, item) => {
    const categoryName = (item?.category?.categoryName || "")
      .trim()
      .toLowerCase();
    if (categoryName === "toy train(regular)") {
      return total + (item.quantity || 0);
    }
    return total;
  }, 0);

  // Check if cart has VIP tickets
  const hasVipTickets = cartItems.some((item) => {
    const categoryName = (item?.category?.categoryName || "")
      .trim()
      .toLowerCase();
    return categoryName === "toy train(vip)";
  });

  // Check if cart has regular tickets
  const hasRegularTickets = cartItems.some((item) => {
    const categoryName = (item?.category?.categoryName || "")
      .trim()
      .toLowerCase();
    return categoryName === "toy train(regular)";
  });

  // Check if VIP seats are available and properly selected
  const [vipSeatsAvailable, setVipSeatsAvailable] = useState(true);
  const [vipSeatsValidationMessage, setVipSeatsValidationMessage] =
    useState("");

  // Check if regular seats are available and properly selected
  const [regularSeatsAvailable, setRegularSeatsAvailable] = useState(true);
  const [regularSeatsValidationMessage, setRegularSeatsValidationMessage] =
    useState("");

  // Confirmation dialog state
  const [showTripConfirmation, setShowTripConfirmation] = useState(false);
  const [pendingTripData, setPendingTripData] = useState(null);

  // Ref to track processed cart state
  const processedCartRef = useRef(null);

  // Reset processed cart when cart items change significantly
  useEffect(() => {
    processedCartRef.current = null;
  }, [cartItems.length]);

  useEffect(() => {
    const defaultClient = clients.filter((clt) => clt.name === "Cash");
    setDefaultClient(defaultClient[0]);
  }, [clients]);

  useEffect(() => {
    dispatch(getAllClients());
  }, [dispatch]);

  useEffect(() => {
    setHasUnsavedChanges(true);
  }, [invoiceData]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue =
          "You have unsaved changes. Are you sure you want to leave this page?";
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [hasUnsavedChanges]);

  // Add a function to safely navigate without the beforeunload warning
  const safeNavigate = (url) => {
    // Set unsaved changes to false first
    setHasUnsavedChanges(false);

    // Use replace instead of href to bypass beforeunload event
    // This prevents the "Leave site?" warning dialog
    window.location.replace(url);
  };

  // Function to clean up beforeunload listener
  const cleanupBeforeUnload = () => {
    // Set unsaved changes to false first
    setHasUnsavedChanges(false);

    // The useEffect cleanup will handle removing the event listener
    // when hasUnsavedChanges changes to false
  };

  useEffect(() => {
    if (invoice && invoice.items && invoice.items.length > 0) {
      const extractedData = invoice.items.map((item) => ({
        _id: item._id,
        quantity: item.quantity,
      }));
      setItemsData(extractedData);
      setInvoiceNumber(invoice.invoiceNumber);
      setInvoiceData(invoice);
      setClient(invoice.client);
    }
  }, [invoice]);

  useEffect(() => {
    if (invoiceData.paymentMode === "Credit") {
      setStatus("Due");
    } else {
      setStatus("Paid");
    }
  }, [invoiceData]);
  
  useEffect(() => {
    async function setInitialInvoiceNumber() {
      if (!invoice) {
        const invoiceNo = await getInvoiceNumber();
        setInvoiceNumber(invoiceNo);
      }
    }
    setInitialInvoiceNumber();
    // lock the header toggle while PaymentDetails is active
    setToggleLocked(true);
    return () => setToggleLocked(false);
  }, []);

  // Get printer name directly from localStorage (no API calls, no user object dependency)
  useEffect(() => {
    try {
      const profile = JSON.parse(localStorage.getItem("profile") || "{}");
      const storedPrinterName = profile?.userProfile?.printerLocation?.printerName;
      if (storedPrinterName) {
        console.log('[PrinterName] ✅ Found in localStorage:', storedPrinterName);
        setPrinterName(storedPrinterName);
      } else {
        console.log('[PrinterName] ❌ Not found in localStorage');
        setPrinterName(null);
      }
    } catch (error) {
      console.error('[PrinterName] ❌ Error reading from localStorage:', error);
      setPrinterName(null);
    }
  }, []);

  useEffect(() => {
    async function getTripNum() {
      try {
        const res = await fetchTripNumber(tripDate);
        setTripNumber(res.data.tripNumber);
      } catch (err) {
        setTripNumber(1);
      }
    }
    getTripNum();
  }, [tripDate]);

  const stockDetailsItems = async (cartItems, invoiceNumber) => {
    const stockItems = await Promise.all(
      cartItems.map(async (item) => ({
        item: item._id,
        transactionType: "SALES",
        qty:
          (await getConvertedQuantity(item, "sale", null, false)) ||
          item.quantity,
        categoryId: item.category.categoryId,
        invoiceId: invoiceNumber,
        createdAt: new Date(),
        unit: item.units.sale.unit,
        references: {
          invoiceId: invoiceNumber,
          transactionRef: "Invoice",
        },
        creator: user?.result?._id || "65549a5b77d1c64130b5db0c",
      }))
    );
    return stockItems;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Set loading state
    setIsProcessing(true);

    try {
      // Get printer name directly from localStorage (no API calls, no user object dependency)
      // Priority: 1. State (printerName), 2. localStorage (direct read)
      let currentPrinterName = printerName;
      
      if (!currentPrinterName) {
        // Get directly from localStorage
        try {
          const profile = JSON.parse(localStorage.getItem("profile") || "{}");
          currentPrinterName = profile?.userProfile?.printerLocation?.printerName;
          if (currentPrinterName) {
            console.log('[PrinterName] ✅ Using from localStorage:', currentPrinterName);
            setPrinterName(currentPrinterName);
          } else {
            console.log('[PrinterName] ❌ Not found in localStorage');
          }
        } catch (error) {
          console.error('[PrinterName] ❌ Error reading from localStorage:', error);
        }
      } else {
        console.log('[PrinterName] ✅ Using from state:', currentPrinterName);
      }
      
      console.log(`[PrinterName] 📝 Final printer name: "${currentPrinterName || 'NONE'}"`);
      const trimmedPrinterName = (currentPrinterName || "").trim();
      if (!trimmedPrinterName) {
        openSnackbar("Please assign a printer in your profile before creating invoices.");
        setIsProcessing(false);
        return;
      }
      setPrinterName(currentPrinterName);

      console.log("invoiceData.invoiceNumber -------------------------------------:", invoiceData)

      // Ensure a valid invoice number exists
      let currentInvoiceNumber = (
        (invoiceData?.invoiceNumber || invoiceNumber || "") ?? ""
      ).toString().trim();

      if (!currentInvoiceNumber) {
        try {
          const nextInvoiceNumber = await getInvoiceNumber();
          if (!nextInvoiceNumber) {
            openSnackbar("Unable to generate invoice number. Please try again.");
            setIsProcessing(false);
            return;
          }
          currentInvoiceNumber = nextInvoiceNumber;
          setInvoiceNumber(nextInvoiceNumber);
          setInvoiceData((prev) => ({ ...prev, invoiceNumber: nextInvoiceNumber }));
        } catch (fetchErr) {
          console.error("Failed to fetch invoice number:", fetchErr);
          openSnackbar("Failed to fetch invoice number. Please try again.");
          setIsProcessing(false);
          return;
        }
      }

      // Always set paymentMode to 'Online' before submit
      if (invoiceData.paymentMode !== "Online") {
        setInvoiceData((prev) => ({ ...prev, paymentMode: "Online" }));
      }

      // Restriction: If cart has toy train items, seat selection is required
      const hasToyTrain = cartItems.some((item) => {
        const categoryName = (item?.category?.categoryName || "")
          .trim()
          .toLowerCase();
        return (
          categoryName === "toy train(regular)" ||
          categoryName === "toy train(vip)"
        );
      });

      if (
        hasToyTrain &&
        !seatlessMode &&
        (!invoiceData.selectedSeats || invoiceData.selectedSeats.length === 0)
      ) {
        openSnackbar("Please select seat(s) for Toy Train tickets.");
        setIsProcessing(false);
        return;
      }

      // Additional validation: Check if regular seats are available for regular tickets
      const hasRegularTickets = cartItems.some((item) => {
        const categoryName = (item?.category?.categoryName || "")
          .trim()
          .toLowerCase();
        return categoryName === "toy train(regular)";
      });

      // Additional validation: Check if VIP seats are available for VIP tickets
      const hasVipTickets = cartItems.some((item) => {
        const categoryName = (item?.category?.categoryName || "")
          .trim()
          .toLowerCase();
        return categoryName === "toy train(vip)";
      });

      let bogies = null;
      if ((hasRegularTickets || hasVipTickets) && !seatlessMode) {
        const bogiesRes = await fetchBogies();
        bogies = bogiesRes.data;
      }

      if (hasRegularTickets && !seatlessMode) {
        const bogiesData = bogies || [];

        // Count regular seats needed
        const totalRegularTickets = cartItems.reduce((total, item) => {
          const categoryName = (item?.category?.categoryName || "")
            .trim()
            .toLowerCase();
          if (categoryName === "toy train(regular)") {
            return total + (item.quantity || 0);
          }
          return total;
        }, 0);

        // Count selected regular seats
        const selectedRegularSeats = invoiceData.selectedSeats.filter(
          (seatId) => {
            const bogieName = seatId[0];
            const seatNumber = Number(seatId.slice(1));
            const bogie = bogiesData.find((b) => b.name === bogieName);
            return bogie && !bogie.vipSeatNumbers.includes(seatNumber);
          }
        ).length;

        if (selectedRegularSeats < totalRegularTickets) {
          openSnackbar(
            `Not enough regular seats! Only ${selectedRegularSeats} regular seats selected, but ${totalRegularTickets} needed. Please reduce quantity or make a new trip.`
          );
          setIsProcessing(false);
          return;
        }
      }

      if (hasVipTickets && !seatlessMode) {
        const bogiesData = bogies || [];

        // Count VIP seats needed
        const totalVipCouple = cartItems.reduce((total, item) => {
          const categoryName = (item?.category?.categoryName || "")
            .trim()
            .toLowerCase();
          const itemName = (item?.itemName || "").trim().toLowerCase();
          if (
            categoryName === "toy train(vip)" &&
            itemName === "vip couple ind(2way)"
          ) {
            return total + (item.quantity || 0);
          }
          return total;
        }, 0);
        const totalVipFamily = cartItems.reduce((total, item) => {
          const categoryName = (item?.category?.categoryName || "")
            .trim()
            .toLowerCase();
          const itemName = (item?.itemName || "").trim().toLowerCase();
          if (
            categoryName === "toy train(vip)" &&
            itemName === "vip family ind (2way)"
          ) {
            return total + (item.quantity || 0);
          }
          return total;
        }, 0);
        const vipCoupleSeatsNeeded = totalVipCouple * 3;
        const vipFamilySeatsNeeded = totalVipFamily * 6;
        const totalVipSeatsNeeded = vipCoupleSeatsNeeded + vipFamilySeatsNeeded;

        // Count selected VIP seats
        const selectedVipSeats = invoiceData.selectedSeats.filter((seatId) => {
          const bogieName = seatId[0];
          const seatNumber = Number(seatId.slice(1));
          const bogie = bogiesData.find((b) => b.name === bogieName);
          return bogie && bogie.vipSeatNumbers.includes(seatNumber);
        }).length;

        if (selectedVipSeats < totalVipSeatsNeeded) {
          openSnackbar(
            `Not enough VIP seats! Only ${selectedVipSeats} VIP seats selected, but ${totalVipSeatsNeeded} needed. Please reduce quantity or make a new trip.`
          );
          setIsProcessing(false);
          return;
        }
      }

      const hasEmptyItems = invoiceData.items.some(
        (item) => !item.quantity && !item.paymentMode
      );
      if (hasEmptyItems || !getTotalPrice || !status) {
        openSnackbar("Please fill the details");
        setIsProcessing(false);
        return;
      }
      if (invoiceData.paymentMode === "") {
        openSnackbar("Please select the Payment Mode");
        setIsProcessing(false);
        return;
      }
      if (invoiceData.paymentMode === "Cash" && !receivedAmount) {
        openSnackbar("Please fill the Amount");
        setIsProcessing(false);
        return;
      } else if (
        invoiceData.paymentMode === "Cash" &&
        receivedAmount < getTotalPrice().total
      ) {
        openSnackbar("Please pay the required amount");
        setIsProcessing(false);
        return;
      }
      if (invoiceData.paymentMode === "Credit" && (!client || client == null)) {
        openSnackbar("Please select the customer");
        setIsProcessing(false);
        return;
      }

      // --- Generate bogieNumbers and seatNumbers from selectedSeats ---
      let bogieNumbers = [];
      let seatNumbers = [];
      if (!seatlessMode && invoiceData.selectedSeats && invoiceData.selectedSeats.length > 0) {
        // Unique bogie letters only
        bogieNumbers = Array.from(
          new Set(invoiceData.selectedSeats.map((s) => s[0]))
        );
        seatNumbers = invoiceData.selectedSeats.map((s) => Number(s.slice(1)));
      }
      // ---------------------------------------------------------------
      const total = isComplimentary ? 0 : getTotalPrice().total;

      if (invoice) {
        console.log("[PayNow] ✅ Preparing payload with printerName:", {
          raw: currentPrinterName,
          trimmed: trimmedPrinterName,
        });
        dispatch(deleteInvoice(invoiceId));
        // Get all calculated values including adjusted amounts
        const priceData = getTotalPrice();
        
        const invoicePayload = {
          ...invoiceData,
          items: cartItems.map((cartItem) => ({
            item: cartItem._id,
            quantity: cartItem.quantity,
          })),
          subTotal: getSubTotalPrice(),
          total,
          invoiceNumber: currentInvoiceNumber,
          receivedAmount:
            invoiceData.paymentMode === "Cash" ? receivedAmount : null,
          change: invoiceData.paymentMode === "Cash" ? calculateChange() : null,
          vat: calculateVat(),
          discount: discountVal ? discountVal.toFixed(2) : 0,
          roundoff: roundoff,
          // New adjusted values for GST compliance (rounded to 2 decimal places)
          originalVat: parseFloat(priceData.originalVat.toFixed(2)),
          adjustedVat: parseFloat(priceData.adjustedVat.toFixed(2)),
          originalSubTotal: parseFloat(priceData.originalSubTotal.toFixed(2)),
          adjustedSubTotal: parseFloat(priceData.adjustedSubTotal.toFixed(2)),
          roundoffSubTotalAdj: parseFloat((priceData.adjustedSubTotal - priceData.originalSubTotal).toFixed(2)),
          roundoffGstAdj: parseFloat((priceData.adjustedVat - priceData.originalVat).toFixed(2)),
          currency: currency,
          status: status,
          client: client
            ? {
                _id: client._id,
                name: client.name,
                email: client.email,
                phone: client.phone,
                address: client.address,
                gstNo: client.gstNo,
                dueDate: client.dueDate,
              }
            : defaultClient,
          creator: [user?.result?._id || user?.result?.googleId],
          createdAt: new Date(),
          isPrintBill: true,
          tripDate,
          tripNumber,
          bogieNumbers,
          seatNumbers,
          hideSeatInfo: seatlessMode,
          isComplimentary,
          printerName: currentPrinterName,
        };
        dispatch(
          createInvoice(invoicePayload, staffCommissionDetailsArray, history)
        );
        dispatch(deleteStockById(invoiceNumber, "SALES"));
        const stockTransactions = await stockDetailsItems(
          cartItems,
          invoiceNumber
        );
        dispatch(createStock(stockTransactions));
        dispatch(updateStaffCommissionDetails(staffCommissionDetailsArray));
        dispatch(
          createInvoice(invoicePayload, staffCommissionDetailsArray, history)
        );
        history.push(`/invoice/${invoice._id}`);
      } else {
        // Get all calculated values including adjusted amounts
        const priceData = getTotalPrice();
        
        const invoicePayload = {
          ...invoiceData,
          items: cartItems.map((cartItem) => ({
            item: cartItem._id,
            quantity: cartItem.quantity,
          })),
          subTotal: getSubTotalPrice(),
          total,
          invoiceNumber: currentInvoiceNumber,
          receivedAmount:
            invoiceData.paymentMode === "Cash" ? receivedAmount : null,
          change: invoiceData.paymentMode === "Cash" ? calculateChange() : null,
          vat: calculateVat(),
          discount: discountVal ? discountVal.toFixed(2) : 0,
          roundoff: roundoff,
          // New adjusted values for GST compliance (rounded to 2 decimal places)
          originalVat: parseFloat(priceData.originalVat.toFixed(2)),
          adjustedVat: parseFloat(priceData.adjustedVat.toFixed(2)),
          originalSubTotal: parseFloat(priceData.originalSubTotal.toFixed(2)),
          adjustedSubTotal: parseFloat(priceData.adjustedSubTotal.toFixed(2)),
          roundoffSubTotalAdj: parseFloat((priceData.adjustedSubTotal - priceData.originalSubTotal).toFixed(2)),
          roundoffGstAdj: parseFloat((priceData.adjustedVat - priceData.originalVat).toFixed(2)),
          currency: currency,
          status: status,
          client: client
            ? {
                _id: client._id,
                name: client.name,
                email: client.email,
                phone: client.phone,
                address: client.address,
                gstNo: client.gstNo,
                dueDate: client.dueDate,
              }
            : defaultClient,
          creator: [user?.result?._id || user?.result?.googleId],
          createdAt: new Date(),
          isPrintBill: true,
          tripDate,
          tripNumber,
          bogieNumbers,
          seatNumbers,
          hideSeatInfo: seatlessMode,
          isComplimentary,
          printerName: currentPrinterName,
        };

        console.log("[PayNow] ✅ Preparing payload with printerName:", {
          raw: currentPrinterName,
          trimmed: trimmedPrinterName,
        });
        console.log("[PayNow] Creating invoice...", invoicePayload);

        // Create invoice first
        const created = await dispatch(
          createInvoice(invoicePayload, staffCommissionDetailsArray, history, {
            suppressRedirect: true,
          })
        );
        const finalInvoiceNumber =
          created?.invoiceNumber || currentInvoiceNumber;

        console.log("[PayNow] Invoice created. Processing stock and print...");

        // Process stock transactions
        const stockTransactions = await stockDetailsItems(
          cartItems,
          finalInvoiceNumber
        );
        dispatch(createStock(stockTransactions));
        console.log("[PayNow] Stock transactions processed.");

        // Simple print job
        try {
          console.log("[PayNow] Starting print job...");
          const printableItems = cartItems.map((ci) => ({
            item: {
              _id: ci._id,
              itemName: ci.itemName,
              category: ci.category,
              units: ci.units,
            },
            quantity: ci.quantity,
          }));
          // const qrPath = created?.qrUrl || invoicePayload?.qrUrl || null;
          const qrTokens = created?.qrTokens || [];


          // If no QR exists, create a simple text-based QR placeholder
          // let finalQrUrl = qrPath;
          // if (!finalQrUrl) {
          //   const qrText = `Invoice: ${invoiceNumber}`;
          //   finalQrUrl = `data:text/plain;base64,${btoa(qrText)}`;
          //   console.log("[PayNow] Created fallback QR with text:", qrText);
          // }

          const { _id: invoiceID } = { ...created };
          // const invoiceForPrint = {
          //   ...invoicePayload,
          //   _id: invoiceID,
          //   items: printableItems,
          //   qrUrl: finalQrUrl,
          // };

          const invoiceForPrint = {
            ...invoicePayload,
            invoiceNumber: finalInvoiceNumber,
            _id: invoiceID,
            items: printableItems,
            qrTokens: qrTokens.map(qr => ({
              station: qr.station,
              qrUrl: qr.qrUrl,
              token: qr.token,
            })),
          };
          

          // Send print job
          const printResponse = await axios.post(
            `${process.env.REACT_APP_API}/print-invoice/${encodeURIComponent(
              finalInvoiceNumber
            )}`,
            {
              invoice: invoiceForPrint,
              userProfile:
                JSON.parse(localStorage.getItem("profile"))?.userProfile || {},
            }
          );

          if (printResponse.status === 200) {
            console.log("[PayNow] Print job completed successfully.");
            openSnackbar(
              "Payment successful! Invoice created and printed successfully."
            );
          } else {
            console.error("[PayNow] Print job failed");
            openSnackbar(
              "Payment successful! Invoice created but printing failed."
            );
          }
        } catch (printErr) {
          console.error(
            "[PayNow] Print job failed:",
            printErr?.message || printErr
          );
          openSnackbar(
            "Payment successful! Invoice created but printing failed."
          );
        }

        // Navigate to POS main screen
        if (typeof window !== "undefined") {
          console.log("[PayNow] Navigating to /PosMainScreen");
          try {
            cleanupBeforeUnload();
            safeNavigate("/PosMainScreen");
          } catch (e) {
            window.location.replace("/PosMainScreen");
          }
        }
      }
      setInvoiceData(initialState);
    } catch (error) {
      console.error("Error submitting payment:", error);
      openSnackbar("Payment failed. Please try again.");
    } finally {
      setIsProcessing(false);
    }
  };

  const handleButton = () => {
    console.log("cartItems", cartItems);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "paymentMode") {
      setInvoiceData({ ...invoiceData, [name]: value });
      if (value === "Cash") {
        setOpenBillDialog(true);
      }
      if (value === "Card") {
        setOpenCardDialog(true);
      }
    }
  };

  const handleCardPayment = (updatedCardData) => {
    setInvoiceData({ ...invoiceData, card: updatedCardData });
  };

  const CustomPaper = (props) => {
    return <Paper elevation={3} {...props} />;
  };

  const clientsProps = {
    options: clients,
    getOptionLabel: (option) => option.name,
  };

  const handleOpenSeatModal = () => {
    dispatch(getBookedSeats(tripDate, tripNumber));
    setTempSelectedSeats(invoiceData.selectedSeats || []);
    setSeatModalOpen(true);
  };

  const handleSaveSeats = () => {
    setInvoiceData({ ...invoiceData, selectedSeats: tempSelectedSeats });
    setSeatModalOpen(false);
  };

  const handleCancelSeats = () => {
    setSeatModalOpen(false);
  };

  const handleResetTrip = (newTripNumber) => {
    setTripNumber(newTripNumber);
    setResetTrigger((prev) => prev + 1); // increment to trigger effect
    setTempSelectedSeats([]); // clear selected seats in parent
    // Reset seats availability to trigger re-validation
    setVipSeatsAvailable(true);
    setVipSeatsValidationMessage("");
    setRegularSeatsAvailable(true);
    setRegularSeatsValidationMessage("");
  };

  const handleConfirmNewTrip = () => {
    if (pendingTripData) {
      const newTripNumber = pendingTripData.tripNumber + 1;
      setTripNumber(newTripNumber);
      setResetTrigger((prev) => prev + 1);

      // Reset seats availability to trigger re-check with new trip
      setRegularSeatsAvailable(true);
      setRegularSeatsValidationMessage("");
      setVipSeatsAvailable(true);
      setVipSeatsValidationMessage("");

      // Clear any existing selected seats
      setInvoiceData((prev) => ({
        ...prev,
        selectedSeats: [],
      }));

      openSnackbar(
        `New trip ${newTripNumber} created! Please try booking again.`
      );
    }
    setShowTripConfirmation(false);
    setPendingTripData(null);
  };

  const handleCancelNewTrip = () => {
    setShowTripConfirmation(false);
    setPendingTripData(null);
  };

  useEffect(() => {
    if (invoiceData.selectedSeats && invoiceData.selectedSeats.length > 0) {
      // Calculate bogie and seat numbers
      const bogieNumbers = Array.from(
        new Set(invoiceData.selectedSeats.map((s) => s[0]))
      );
      const seatNumbers = invoiceData.selectedSeats.map((s) =>
        Number(s.slice(1))
      );
      console.log("Selected Seats:", invoiceData.selectedSeats);
      console.log("Bogie Numbers:", bogieNumbers);
      console.log("Seat Numbers:", seatNumbers);
    }
  }, [invoiceData.selectedSeats]);

  // Auto-select and save seats for Toy Train (Regular) and VIP tickets without opening modal
  // useEffect(() => {
  //   let isMounted = true; // Flag to prevent state updates if component unmounts

  //   async function autoSelectAndSaveSeats() {
  //     // In crowd mode, skip all seat availability checks/auto-selection
  //     if (seatlessMode) {
  //       if (isMounted) {
  //         setRegularSeatsAvailable(true);
  //         setRegularSeatsValidationMessage("");
  //         setVipSeatsAvailable(true);
  //         setVipSeatsValidationMessage("");
  //         setShowTripConfirmation(false);
  //       }
  //       return;
  //     }
  //     // Create a unique key for current cart state
  //     const cartKey = JSON.stringify({
  //       cartItems: cartItems.map((item) => ({
  //         id: item._id,
  //         quantity: item.quantity,
  //       })),
  //       tripDate,
  //       tripNumber,
  //     });

  //     // Skip if we've already processed this exact cart state
  //     if (processedCartRef.current === cartKey) {
  //       console.log("Skipping duplicate cart processing");
  //       return;
  //     }

  //     // Count regular tickets
  //     const totalQtyToyTrainRegular = cartItems.reduce((total, item) => {
  //       const categoryName = (item?.category?.categoryName || "")
  //         .trim()
  //         .toLowerCase();
  //       if (categoryName === "toy train(regular)") {
  //         return total + (item.quantity || 0);
  //       }
  //       return total;
  //     }, 0);

  //     // Count VIP couple and family tickets
  //     const totalVipCouple = cartItems.reduce((total, item) => {
  //       const categoryName = (item?.category?.categoryName || "")
  //         .trim()
  //         .toLowerCase();
  //       const itemName = (item?.itemName || "").trim().toLowerCase();
  //       if (
  //         categoryName === "toy train(vip)" &&
  //         itemName === "vip couple ind(2way)"
  //       ) {
  //         return total + (item.quantity || 0);
  //       }
  //       return total;
  //     }, 0);
  //     const totalVipFamily = cartItems.reduce((total, item) => {
  //       const categoryName = (item?.category?.categoryName || "")
  //         .trim()
  //         .toLowerCase();
  //       const itemName = (item?.itemName || "").trim().toLowerCase();
  //       if (
  //         categoryName === "toy train(vip)" &&
  //         itemName === "vip family ind (2way)"
  //       ) {
  //         return total + (item.quantity || 0);
  //       }
  //       return total;
  //     }, 0);
  //     const vipCoupleSeatsNeeded = totalVipCouple * 3;
  //     const vipFamilySeatsNeeded = totalVipFamily * 6;
  //     const totalVipSeatsNeeded = vipCoupleSeatsNeeded + vipFamilySeatsNeeded;

  //     if (totalQtyToyTrainRegular > 0 || totalVipSeatsNeeded > 0) {
  //       // Fetch bogies and booked seats
  //       const [bogiesRes, bookedSeatsRes] = await Promise.all([
  //         fetchBogies(),
  //         fetchBookedSeats(tripDate, tripNumber),
  //       ]);

  //       // Check if component is still mounted before proceeding
  //       if (!isMounted) return;

  //       const bogies = bogiesRes.data;
  //       const bookedSeats = bookedSeatsRes.data;

  //       let autoSelectedRegular = [];
  //       let autoSelectedVip = [];

  //       // Calculate available seats for both types first
  //       const availableRegularSeats = bogies
  //         .filter((b) => b.isActive)
  //         .reduce((acc, bogie) => {
  //           for (let i = 1; i <= bogie.totalSeats; i++) {
  //             if (!bogie.vipSeatNumbers.includes(i)) {
  //               const seatId = `${bogie.name}${i}`;
  //               if (!bookedSeats.includes(seatId)) {
  //                 acc++;
  //               }
  //             }
  //           }
  //           return acc;
  //         }, 0);

  //       const availableVipSeats = bogies
  //         .filter((b) => b.isActive)
  //         .reduce((acc, bogie) => {
  //           for (const vipNo of bogie.vipSeatNumbers) {
  //             const seatId = `${bogie.name}${vipNo}`;
  //             if (!bookedSeats.includes(seatId)) {
  //               acc++;
  //             }
  //           }
  //           return acc;
  //         }, 0);

  //       console.log("Seat availability check:", {
  //         availableRegularSeats,
  //         totalQtyToyTrainRegular,
  //         availableVipSeats,
  //         totalVipSeatsNeeded,
  //         bookedSeats: bookedSeats.length,
  //         bogies: bogies.length,
  //       });

  //       // Check both regular and VIP seat availability
  //       let regularSeatsInsufficient = false;
  //       let vipSeatsInsufficient = false;

  //       if (
  //         totalQtyToyTrainRegular > 0 &&
  //         availableRegularSeats < totalQtyToyTrainRegular
  //       ) {
  //         regularSeatsInsufficient = true;
  //       } else if (totalQtyToyTrainRegular > 0) {
  //         setRegularSeatsAvailable(true);
  //         setRegularSeatsValidationMessage("");
  //       }

  //       if (
  //         totalVipSeatsNeeded > 0 &&
  //         availableVipSeats < totalVipSeatsNeeded
  //       ) {
  //         vipSeatsInsufficient = true;
  //       } else if (totalVipSeatsNeeded > 0) {
  //         setVipSeatsAvailable(true);
  //         setVipSeatsValidationMessage("");
  //       }

  //       // Check if BOTH seat types are 0 available (regardless of what user is booking)
  //       const bothSeatTypesEmpty =
  //         availableRegularSeats === 0 && availableVipSeats === 0;

  //       // Show dialog if both seat types are empty OR if user is booking both types and both are insufficient
  //       if (
  //         bothSeatTypesEmpty ||
  //         (regularSeatsInsufficient && vipSeatsInsufficient)
  //       ) {
  //         // Both types insufficient - show confirmation dialog
  //         const commonMessage = `All seats are full! Please reduce quantity or make a new trip.`;
  //         console.log("All seats insufficient:", commonMessage);

  //         if (isMounted) {
  //           setRegularSeatsAvailable(false);
  //           setRegularSeatsValidationMessage(commonMessage);
  //           setVipSeatsAvailable(false);
  //           setVipSeatsValidationMessage("");

  //           // Show confirmation dialog for new trip
  //           setPendingTripData({
  //             tripNumber,
  //             regularSeats: {
  //               available: availableRegularSeats,
  //               needed: totalQtyToyTrainRegular,
  //             },
  //             vipSeats: {
  //               available: availableVipSeats,
  //               needed: totalVipSeatsNeeded,
  //             },
  //           });
  //           setShowTripConfirmation(true);

  //           setInvoiceData((prev) => ({
  //             ...prev,
  //             selectedSeats: [],
  //           }));
  //         }
  //         return; // Exit early, don't proceed with booking
  //       }

  //       // Check individual seat types (only one type insufficient)
  //       if (regularSeatsInsufficient) {
  //         // Only regular seats insufficient
  //         const message = `Not enough regular seats! Only ${availableRegularSeats} regular seats available, but ${totalQtyToyTrainRegular} needed. Please reduce quantity or make a new trip.`;
  //         console.log("Regular seats insufficient:", message);

  //         if (isMounted) {
  //           setRegularSeatsAvailable(false);
  //           setRegularSeatsValidationMessage(message);
  //           setVipSeatsAvailable(true);
  //           setVipSeatsValidationMessage("");

  //           setInvoiceData((prev) => ({
  //             ...prev,
  //             selectedSeats: [],
  //           }));
  //         }
  //         return; // Exit early, don't proceed with booking
  //       }

  //       if (vipSeatsInsufficient) {
  //         // Only VIP seats insufficient
  //         const message = `Not enough VIP seats! Only ${availableVipSeats} VIP seats available, but ${totalVipSeatsNeeded} needed. Please reduce quantity or make a new trip.`;
  //         console.log("VIP seats insufficient:", message);

  //         if (isMounted) {
  //           setVipSeatsAvailable(false);
  //           setVipSeatsValidationMessage(message);
  //           setRegularSeatsAvailable(true);
  //           setRegularSeatsValidationMessage("");

  //           setInvoiceData((prev) => ({
  //             ...prev,
  //             selectedSeats: [],
  //           }));
  //         }
  //         return; // Exit early, don't proceed with booking
  //       }

  //       // If we reach here, both seat types are available, proceed with selection
  //       if (totalQtyToyTrainRegular > 0) {
  //         const safeRegularCount = Math.min(
  //           totalQtyToyTrainRegular,
  //           availableRegularSeats
  //         );
  //         autoSelectedRegular = getAutoSelectedSeats({
  //           bogies,
  //           bookedSeats,
  //           count: safeRegularCount,
  //           alreadySelected: [],
  //         });
  //       }

  //       if (totalVipSeatsNeeded > 0) {
  //         autoSelectedVip = getAutoSelectedVipSeats({
  //           bogies,
  //           bookedSeats: [...bookedSeats, ...autoSelectedRegular],
  //           count: totalVipSeatsNeeded,
  //           alreadySelected: [],
  //         });
  //       }

  //       // Combine only what is needed
  //       const allSelectedSeats = [...autoSelectedRegular, ...autoSelectedVip];

  //       if (isMounted) {
  //         setInvoiceData((prev) => ({
  //           ...prev,
  //           selectedSeats: allSelectedSeats,
  //         }));
  //       }
  //     } else {
  //       // If no tickets, clear selectedSeats
  //       if (
  //         isMounted &&
  //         invoiceData.selectedSeats &&
  //         invoiceData.selectedSeats.length > 0
  //       ) {
  //         setInvoiceData((prev) => ({ ...prev, selectedSeats: [] }));
  //       }
  //     }

  //     // Mark this cart state as processed
  //     if (isMounted) {
  //       processedCartRef.current = cartKey;
  //     }
  //   }

  //   // Add a small delay to prevent rapid successive calls
  //   const timeoutId = setTimeout(() => {
  //     autoSelectAndSaveSeats();
  //   }, 100);

  //   return () => {
  //     isMounted = false;
  //     clearTimeout(timeoutId);
  //   };
  //   // eslint-disable-next-line
  // }, [cartItems, tripDate, tripNumber, seatlessMode]);

  useEffect(() => {
  let isMounted = true;

  async function autoSelectAndSaveSeats() {
    if (seatlessMode) {
      if (isMounted) {
        setRegularSeatsAvailable(true);
        setRegularSeatsValidationMessage("");
        setVipSeatsAvailable(true);
        setVipSeatsValidationMessage("");
        setShowTripConfirmation(false);
      }
      return;
    }

    const cartKey = JSON.stringify({
      cartItems: cartItems.map((item) => ({
        id: item._id,
        quantity: item.quantity,
      })),
      tripDate,
      tripNumber,
    });

    if (processedCartRef.current === cartKey) return;

    // ----------------------------
    // COUNT TICKETS
    // ----------------------------
    let totalQtyToyTrainRegular = 0;
    let totalVipCouple = 0;
    let totalVipFamily = 0;

    cartItems.forEach((item) => {
      const categoryName = (item?.category?.categoryName || "")
        .trim()
        .toLowerCase();
      const itemName = (item?.itemName || "").trim().toLowerCase();

      if (categoryName === "toy train(regular)") {
        totalQtyToyTrainRegular += item.quantity || 0;
      }

      if (
        categoryName === "toy train(vip)" &&
        itemName === "vip couple ind (2way)"
      ) {
        totalVipCouple += item.quantity || 0;
      }

      if (
        categoryName === "toy train(vip)" &&
        itemName === "vip family ind (2way)"
      ) {
        totalVipFamily += item.quantity || 0;
      }
    });

    if (
      totalQtyToyTrainRegular === 0 &&
      totalVipCouple === 0 &&
      totalVipFamily === 0
    ) {
      if (isMounted) {
        setInvoiceData((p) => ({ ...p, selectedSeats: [] }));
      }
      return;
    }

    // ----------------------------
    // FETCH DATA
    // ----------------------------
    const [bogiesRes, bookedSeatsRes] = await Promise.all([
      fetchBogies(),
      fetchBookedSeats(tripDate, tripNumber),
    ]);

    if (!isMounted) return;

    const bogies = bogiesRes.data.filter((b) => b.isActive);
    const bookedSeats = bookedSeatsRes.data || [];
    const bookedSet = new Set(bookedSeats);

    // ----------------------------
    // REGULAR SEAT AVAILABILITY
    // ----------------------------
    let availableRegularSeats = 0;

    bogies.forEach((bogie) => {
      for (let i = 1; i <= bogie.totalSeats; i++) {
        const seatId = `${bogie.name}${i}`;

        const isVipSeat = bogie.vipSeatGroups?.some((g) =>
          g.seats.includes(i)
        );

        if (!isVipSeat && !bookedSet.has(seatId)) {
          availableRegularSeats++;
        }
      }
    });

    // ----------------------------
    // VIP GROUP AVAILABILITY
    // ----------------------------
    let availableVipCoupleGroups = 0;
    let availableVipFamilyGroups = 0;

    bogies.forEach((bogie) => {
      (bogie.vipSeatGroups || []).forEach((group) => {
        const groupFree = group.seats.every(
          (s) => !bookedSet.has(`${bogie.name}${s}`)
        );

        if (!groupFree) return;

        if (group.type === "couple") availableVipCoupleGroups++;
        if (group.type === "family") availableVipFamilyGroups++;
      });
    });

    // ----------------------------
    // VALIDATION
    // ----------------------------
    if (totalQtyToyTrainRegular > availableRegularSeats) {
      setRegularSeatsAvailable(false);
      setRegularSeatsValidationMessage(
        `Only ${availableRegularSeats} regular seats available`
      );
      return;
    }

    if (
      totalVipCouple > availableVipCoupleGroups ||
      totalVipFamily > availableVipFamilyGroups
    ) {
      setVipSeatsAvailable(false);
      setVipSeatsValidationMessage("VIP seats not available");
      return;
    }

    setRegularSeatsAvailable(true);
    setVipSeatsAvailable(true);
    setRegularSeatsValidationMessage("");
    setVipSeatsValidationMessage("");

    // ----------------------------
    // AUTO SELECT REGULAR SEATS
    // ----------------------------
    let autoSelectedRegular = [];

    if (totalQtyToyTrainRegular > 0) {
      autoSelectedRegular = getAutoSelectedSeats({
        bogies,
        bookedSeats,
        count: totalQtyToyTrainRegular,
        alreadySelected: [],
      });
    }

    // ----------------------------
    // AUTO SELECT VIP GROUPS
    // ----------------------------
    let autoSelectedVip = [];
    const usedVipGroups = new Set();

    bogies.forEach((bogie) => {
      (bogie.vipSeatGroups || []).forEach((group) => {
        if (group.type === "couple" && totalVipCouple > 0) {
          if (
            group.seats.every(
              (s) =>
                !bookedSet.has(`${bogie.name}${s}`) &&
                !usedVipGroups.has(group)
            )
          ) {
            autoSelectedVip.push(
              ...group.seats.map((s) => `${bogie.name}${s}`)
            );
            usedVipGroups.add(group);
            totalVipCouple--;
          }
        }

        if (group.type === "family" && totalVipFamily > 0) {
          if (
            group.seats.every(
              (s) =>
                !bookedSet.has(`${bogie.name}${s}`) &&
                !usedVipGroups.has(group)
            )
          ) {
            autoSelectedVip.push(
              ...group.seats.map((s) => `${bogie.name}${s}`)
            );
            usedVipGroups.add(group);
            totalVipFamily--;
          }
        }
      });
    });

    // ----------------------------
    // SAVE SEATS
    // ----------------------------
    const allSelectedSeats = [...autoSelectedRegular, ...autoSelectedVip];

    if (isMounted) {
      setInvoiceData((prev) => ({
        ...prev,
        selectedSeats: allSelectedSeats,
      }));
      processedCartRef.current = cartKey;
    }
  }

  const timeoutId = setTimeout(autoSelectAndSaveSeats, 100);

  return () => {
    isMounted = false;
    clearTimeout(timeoutId);
  };
}, [cartItems, tripDate, tripNumber, seatlessMode]);


  // Set paymentMode to 'Online' by default in initialState
  useEffect(() => {
    setInvoiceData((prev) => ({
      ...prev,
      paymentMode: "Online",
    }));
  }, []);

  // Fetch bogies data
  useEffect(() => {
    const fetchBogiesData = async () => {
      try {
        const res = await fetchBogies();
        setBogies(res.data.filter(b => b.isActive));
      } catch (error) {
        console.error('Error fetching bogies:', error);
      }
    };
    fetchBogiesData();
  }, []);

  return (
    <Fade in timeout={600}>
      <Container maxWidth="sm" sx={{ p: 1 }}>
        <AddClient setOpen={setOpen} open={open} />
        <Card className={classes.card} elevation={3}>
          <CardContent sx={{ p: 2 }}>
            <Typography
              variant="h6"
              className={classes.sectionTitle}
              align="center"
              gutterBottom
            >
              Payment Details
            </Typography>
            <form onSubmit={handleSubmit}>
              {!openBillDialog && !openCardDialog && (
                <Grid container spacing={1.5}>
                  <Grid item xs={12}>
                    <Typography
                      variant="subtitle2"
                      className={classes.sectionTitle}
                      gutterBottom
                    >
                      Customer
                    </Typography>
                    {client ? (
                      <Zoom in timeout={400}>
                        <ClientInfoCard client={client} setClient={setClient} />
                      </Zoom>
                    ) : (
                      <>
                        <Autocomplete
                          {...clientsProps}
                          PaperComponent={CustomPaper}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Select Customer"
                              size="small"
                              variant="outlined"
                            />
                          )}
                          value={clients?.name}
                          onChange={(event, value) => setClient(value)}
                        />
                        <Zoom in timeout={400}>
                          <Chip
                            avatar={
                              <Avatar
                                style={{
                                  backgroundColor: "#ef7f1a",
                                  color: "white",
                                }}
                              >
                                +
                              </Avatar>
                            }
                            label="New Customer"
                            onClick={() => setOpen(true)}
                            variant="outlined"
                            className={classes.newCustomerChip}
                          />
                        </Zoom>
                      </>
                    )}
                  </Grid>
                  <Grid item xs={12}>
                    <label style={{ display: "flex", alignItems: "center" }}>
                      <input
                        type="checkbox"
                        checked={isComplimentary}
                        onChange={(e) => setIsComplimentary(e.target.checked)}
                        style={{ marginRight: 8 }}
                      />
                      Complimentary Ticket
                    </label>
                    {isComplimentary && (
                      <Chip
                        label="Complimentary Ticket Applied"
                        color="secondary"
                        style={{ marginTop: 8 }}
                      />
                    )}
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle2" color="textSecondary">
                      Invoice Number
                    </Typography>
                    <Typography
                      variant="h6"
                      className={classes.invoiceNumber}
                      gutterBottom
                    >
                      {invoiceNumber}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle2" color="textSecondary">
                      Trip Number
                    </Typography>
                    <Typography
                      variant="h6"
                      className={classes.invoiceNumber}
                      gutterBottom
                    >
                      {tripNumber}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      variant="subtitle2"
                      className={classes.sectionTitle}
                      gutterBottom
                    >
                      Seats
                    </Typography>
                    {seatlessMode ? null : (invoiceData.selectedSeats &&
                      invoiceData.selectedSeats.length > 0 && (
                        <div
                          style={{
                            marginBottom: 8,
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 8,
                          }}
                        >
                          {(() => {
                            const categorized = {
                              regular: [],
                              couple: [],
                              family: []
                            };

                            invoiceData.selectedSeats.forEach(seat => {
                              let type = 'regular';
                              for (const bogie of bogies) {
                                if (seat.startsWith(bogie.name)) {
                                  const seatNum = Number(seat.slice(bogie.name.length));
                                  const group = bogie.vipSeatGroups?.find(g => g.seats.includes(seatNum));
                                  if (group) {
                                    if (group.type.toLowerCase() === 'couple') type = 'couple';
                                    else if (group.type.toLowerCase() === 'family') type = 'family';
                                  }
                                  break;
                                }
                              }
                              categorized[type].push(seat);
                            });

                            return ['regular', 'couple', 'family'].map(type => {
                              if (categorized[type].length === 0) return null;
                              const seatsByBogie = categorized[type].reduce((acc, seat) => {
                                const bogie = seat[0];
                                const seatNum = Number(seat.slice(1));
                                if (!acc[bogie]) acc[bogie] = [];
                                acc[bogie].push(seatNum);
                                return acc;
                              }, {});

                              return Object.entries(seatsByBogie).map(([bogie, seats]) => (
                                <Chip
                                  key={`${type}-${bogie}`}
                                  label={`${type === 'regular' ? 'Regular' : type === 'couple' ? 'VIP Couple' : 'VIP Family'} डिब्बा ${bogie} : सीट :- ${seats
                                    .sort((a, b) => a - b)
                                    .join(", ")}`}
                                  className={classes.chip}
                                  style={{
                                    fontSize: 13,
                                    fontWeight: 500,
                                    padding: "8px 2px",
                                    backgroundColor: type === 'regular' ? '#e0e0e0' : type === 'couple' ? '#ffeb3b' : '#ff9800',
                                    color: type === 'regular' ? '#000' : '#000',
                                  }}
                                  size="small"
                                />
                              ));
                            });
                          })()}
                        </div>
                      ))}
                    {!seatlessMode && (<Button
                      onClick={handleOpenSeatModal}
                      variant="outlined"
                      size="small"
                      fullWidth
                    >
                      Select Seats For Toy Train Tickets
                    </Button>)}
        {(!seatlessMode && ((hasVipTickets && !vipSeatsAvailable) ||
          (hasRegularTickets && !regularSeatsAvailable)) &&
          (!invoiceData.selectedSeats ||
            invoiceData.selectedSeats.length === 0)) && (
                        <Button
                          onClick={() => {
                            // Reset trip to create new trip
                            handleResetTrip(tripNumber + 1);
                            // Reset seats availability to trigger re-check
                            setVipSeatsAvailable(true);
                            setVipSeatsValidationMessage("");
                            setRegularSeatsAvailable(true);
                            setRegularSeatsValidationMessage("");
                          }}
                          variant="contained"
                          color="secondary"
                          size="small"
                          fullWidth
                          style={{ marginTop: 8 }}
                        >
                          {hasVipTickets &&
                          !vipSeatsAvailable &&
                          hasRegularTickets &&
                          !regularSeatsAvailable
                            ? "Make New Trip (All Seats Full)"
                            : hasVipTickets && !vipSeatsAvailable
                            ? "Make New Trip (VIP Seats Full)"
                            : hasRegularTickets && !regularSeatsAvailable
                            ? "Make New Trip (Regular Seats Full)"
                            : "Make New Trip (Seats Full)"}
                        </Button>
                      )}
                  </Grid>
                  {/* Hide PaymentOptions UI */}
                  {/* <Grid item xs={12}>
                    <Typography
                      variant="subtitle1"
                      className={classes.sectionTitle}
                      gutterBottom
                    >
                      Payment
                    </Typography>
                    <PaymentOptions
                      invoiceData={invoiceData}
                      handleInputChange={handleInputChange}
                    />
                  </Grid> */}
                </Grid>
              )}
              {openBillDialog && (
                <BillDialog
                  currency={currency}
                  setOpenBillDialog={setOpenBillDialog}
                  invoice={invoice}
                />
              )}
              {openCardDialog && (
                <CardDialog
                  handleCardPayment={handleCardPayment}
                  invoiceData={invoiceData}
                  currency={currency}
                  setOpenCardDialog={setOpenCardDialog}
                />
              )}
              <div className={classes.saveButton}>
                {!seatlessMode && hasVipTickets &&
                  !vipSeatsAvailable &&
                  vipSeatsValidationMessage && (
                    <Typography
                      variant="body2"
                      color="error"
                      align="center"
                      style={{ marginBottom: 8, fontSize: "0.875rem" }}
                    >
                      {vipSeatsValidationMessage}
                    </Typography>
                  )}
                {!seatlessMode && hasRegularTickets &&
                  !regularSeatsAvailable &&
                  regularSeatsValidationMessage && (
                    <Typography
                      variant="body2"
                      color="error"
                      align="center"
                      style={{ marginBottom: 8, fontSize: "0.875rem" }}
                    >
                      {regularSeatsValidationMessage}
                    </Typography>
                  )}
                <Zoom in timeout={400}>
                  <Button
                    variant="contained"
                    style={{ backgroundColor: "#ef7f1a", color: "white" }}
                    type="submit"
                    size="large"
                    startIcon={<SaveIcon />}
                    className={classes.button}
                    disabled={
                      isProcessing ||
                      (hasVipTickets && !vipSeatsAvailable) ||
                      (hasRegularTickets && !regularSeatsAvailable)
                    }
                  >
                    {isProcessing
                      ? "Processing..."
                      : invoice
                      ? "Update"
                      : "Pay Now"}
                  </Button>
                </Zoom>
              </div>
            </form>
          </CardContent>
        </Card>
        <Dialog
          open={seatModalOpen}
          onClose={handleCancelSeats}
          maxWidth="md"
          fullWidth
          className={classes.dialog}
          PaperProps={{
            style: {
              display: "flex",
              flexDirection: "column",
              maxHeight: "90vh",
            },
          }}
        >
          <DialogTitle>Select Seats (Trip: {tripNumber})</DialogTitle>
          {/* 
          <MuiAlert
            severity="info"
            icon={false}
            style={{
              background: "linear-gradient(90deg, #1976d2 0%, #64b5f6 100%)",
              color: "#fff",
              fontWeight: 600,
              fontSize: "1.05rem",
              borderRadius: 6,
              letterSpacing: 0.2,
              boxShadow: "0 2px 8px rgba(25, 118, 210, 0.08)",
              display: "flex",
              alignItems: "center",
            }}
          >
            <span
              role="img"
              aria-label="info"
              style={{ marginRight: 8, fontSize: 22 }}
            >
              ℹ️
            </span>
            <span>
              <strong>Note:</strong> Auto seat selection is only for{" "}
              <b>Regular</b> seats.
              <br />
              For <b>VIP</b> seats, please book manually.
            </span>
          </MuiAlert> */}

          <DialogContent
            style={{
              overflow: "hidden",
              display: "flex",
              flex: "1 1 auto",
              paddingTop: 12,
            }}
          >
            <div style={{ flex: 1, minHeight: 0 }}>
              <SeatSelection
                open={seatModalOpen}
                selectedSeats={tempSelectedSeats}
                setSelectedSeats={setTempSelectedSeats}
                tripDate={tripDate}
                tripNumber={tripNumber}
                showResetButton={true}
                onResetTrip={handleResetTrip}
                currentInvoiceId={invoiceId}
                autoSelectCount={totalQtyToyTrainRegular}
                resetTrigger={resetTrigger}
              />
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCancelSeats} className={classes.button}>
              Cancel
            </Button>
            <Button
              onClick={handleSaveSeats}
              color="primary"
              variant="contained"
              className={classes.button}
              style={{ color: "#fff" }} 
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>

        {/* New Trip Confirmation Dialog */}
        <Dialog
          open={showTripConfirmation}
          onClose={handleCancelNewTrip}
          maxWidth="sm"
          fullWidth
          className={classes.dialog}
        >
          <DialogTitle style={{ textAlign: "center", color: "#d32f2f" }}>
            All Seats Are Full!
          </DialogTitle>
          <DialogContent>
            <Typography
              variant="body1"
              style={{ marginBottom: 16, textAlign: "center" }}
            >
              Current trip has no available seats:
            </Typography>

            <Typography variant="body1" style={{ textAlign: "center" }}>
              Would you like to create a new trip ?
            </Typography>
          </DialogContent>
          <DialogActions
            style={{ justifyContent: "center", padding: "16px 24px" }}
          >
            <Button
              onClick={handleCancelNewTrip}
              variant="outlined"
              color="secondary"
              className={classes.button}
              style={{ marginRight: 16 }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleConfirmNewTrip}
              variant="contained"
              color="primary"
              className={classes.button}
              style={{ backgroundColor: "#ef7f1a", color: "white" }}
            >
              Create New Trip
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Fade>
  );
};

export default PaymentDetails;
